<template>
<div role="group" class="b-form-group form-group">
  <div class="form-row">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('GROUPNAME')">
        <inputvalidation :formerror="formError" name="groupName">
          <b-form-input type="text" v-model="formData.groupName"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('COPYACLFROMGROUP')">
        <inputvalidation :formerror="formError" name="copyGroupId">
            <b-form-select :options="aclGroups.root" 
                v-model="formData.copyGroupId"
                value-field="groupId"
                text-field="groupName">
            </b-form-select>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
</div>
</template>

<script>
export default {
    name: 'AclGroups',
    props: ['formData', 'formError', 'aclGroups'],
};
</script>
